import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M20.5 3.00003H20.2C19.936 2.9987 19.6743 3.04968 19.43 3.15003L15 5.00003L10.75 3.23003C10.3855 3.07845 9.99474 3.00029 9.60001 3.00003H8.40001C8.00528 3.00029 7.61448 3.07845 7.25001 3.23003L3.62001 4.74002C3.43582 4.81569 3.27841 4.94463 3.16795 5.11032C3.05749 5.276 2.99902 5.4709 3.00001 5.67003V20.5C3.00001 20.6326 3.05269 20.7598 3.14646 20.8536C3.24023 20.9473 3.3674 21 3.50001 21H3.80001C4.06406 21.0013 4.32576 20.9504 4.57001 20.85L9.00001 19L13.25 20.77C13.6145 20.9216 14.0053 20.9998 14.4 21H15.6C15.9947 20.9998 16.3855 20.9216 16.75 20.77L20.38 19.26C20.5642 19.1844 20.7216 19.0554 20.8321 18.8897C20.9425 18.724 21.001 18.5292 21 18.33V3.50003C21 3.36742 20.9473 3.24024 20.8536 3.14647C20.7598 3.0527 20.6326 3.00003 20.5 3.00003ZM5.00001 6.33002L8.00001 5.08002V17.25L5.00001 18.5V6.33002ZM10 17.25V5.08002L14 6.75003V18.92L10 17.25ZM19 17.67L16 18.92V6.75003L19 5.50003V17.67Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgMapOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgMapOutline;
